export default __webpack_public_path__ + "static/media/checked.e1969a10.svg";